/** Store-scoped keys: switching stores never shares cache. */
export const menuKeys = {
  all: (storeId: string) => ['stores', storeId, 'menus'] as const,
  list: (storeId: string) => [...menuKeys.all(storeId), 'list'] as const,
  detail: (storeId: string, id: string) => [...menuKeys.all(storeId), 'detail', id] as const,
};
